import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { browserHistory } from 'react-router';
import CreateThreadForm from './elements/CreateThreadForm';
import { BackButton } from '../../../../common/elements'
import { createThread } from '../../../../../actions/forums/forums';

class CreateThread extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            isOpen: false,
        }
    }

    handleOnClose = ( ev ) => {
        ev.preventDefault();
        const { params } = this.props;
        this.setState( { isOpen: false } );
		browserHistory.push( `/forums/${ params.categoryId }/threads` );
    }

    postThread = ( thread ) => {
        const { createThread, params, resetForm } = this.props, personId = localStorage.getItem('person_id');
        createThread( params.categoryId, thread, personId );
        resetForm();
        this.setState( { isOpen: true } );
    };

    render() {
        return (
            <article className="container forum-body">
                <aside className="row">
                    <div className="col-xs-12">
                    </div>
                </aside>
                <main>
                    <BackButton/>
                    <section className="row">
                        <div className="col-xs-12">
                            <h3 className="h3 brand-color">Create thread</h3>
                        </div>
                    </section>
                    <section className="row">
                        <div className="col-xs-12">
                            <CreateThreadForm onSubmit={ thread => this.postThread( thread ) }
                                              handleClose={ e => this.handleOnClose( e ) }
                                              isOpen={ this.state.isOpen }
                            />
                        </div>
                    </section>
                </main>
            </article>

        );
    };
}

CreateThread.propTypes = {
	params: PropTypes.object,
	createThread: PropTypes.func,
	resetForm: PropTypes.func
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        createThread: ( categoryId, thread, personId ) => dispatch( createThread( categoryId, thread, personId ) ),
        resetForm: () => dispatch( reset( 'create_thread' ) ),
    };
};

export default connect( null, mapDispatchToProps )( CreateThread );



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/CreateThread.js